import { createFileRoute } from '@tanstack/react-router';
import type { BuilderMode } from '@/api/questionnaires/types';
import { BuilderPage } from '@/app/(client)/questionnaires/-components/BuilderPage';

export const Route = createFileRoute(
  '/(client)/questionnaires/(pages)/(detail)/$id/edit/',
)({
  component: BuilderRoute,
});

function BuilderRoute() {
  const { id } = Route.useParams();
  // Detail-level layout owns search validation + data prefetch.
  // We mirror its mode resolution so the builder hook hits the right endpoint.
  const search = Route.useSearch() as {
    type?: 'questionnaire' | 'template' | undefined;
    isTemplate?: string | boolean | undefined;
  };
  const isTemplate = search.isTemplate === true || search.isTemplate === 'true';
  const mode: BuilderMode =
    search.type === 'template' || isTemplate ? 'template' : 'questionnaire';
  return <BuilderPage key={id} mode={mode} id={id} />;
}
